import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'

export const Divider = styled('div')<{
    margin?: string
    vertical?: boolean
    height?: string
    theme?: TTheme
    color?: string
}>`
    height: ${({ vertical, height }) => (vertical ? height || '100%' : '1px')};
    width: ${({ vertical }) => (vertical ? '1px' : '100%')};
    background-color: ${({ color, theme }) => color || theme.colors.greys[200]};
    margin: ${({ margin }) => margin || '0'};
    cursor: default;
`
